import { render, staticRenderFns } from "./WikiHistory.vue?vue&type=template&id=f1250c64&"
import script from "./WikiHistory.vue?vue&type=script&lang=ts&"
export * from "./WikiHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports